import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
Vue.use(Vuetify);
const theme = localStorage.getItem("theme");
if (!theme) {
  localStorage.setItem("theme",'light')
}
export default new Vuetify({
  rtl: true,
  theme: {
    options: {
      themeCache: {
        get: (key) => localStorage.getItem(key),
        set: (key, value) => localStorage.setItem(key, value),
      },
    },
    dark: theme === 'dark' ,
    themes: {
      light: {
        primary: colors.cyan,
        secondary: colors.deepOrange,
        accent: colors.deepOrange,
        error: "#b71c1c",
      },
    },
  },
});
